import { useDeleteEntityApi } from '@/common/api/deleteEntityApi';
import { useProductionOrderStore } from 'shared/productionOrders/stores/productionOrderStore';

export function useDeleteProductionOrderApi() {
  const store = useProductionOrderStore();

  return useDeleteEntityApi({
    url: 'productionorder',
    translate: (t) => t.productionOrders.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({
        ok: true,
      });
    },
  });
}
